import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Button from '../../../../components/Button'

import useStyles from '../../../../styles/common/stepForms'

function Step({ children, stepTitle, handleContinue, btnText = 'Continue' }) {
  const classes = useStyles()

  const { t } = useTranslation()

  return (
    <>
      {stepTitle && <div className={classes.stepTitle}>{t(stepTitle)}</div>}
      <div className={classes.stepBody}>{children}</div>
      {handleContinue && (
        <div className={classes.stepFooter}>
          <Button type="button" className="dark" onClick={handleContinue}>
            {btnText}
          </Button>
        </div>
      )}
    </>
  )
}

Step.propTypes = {
  stepTitle: PropTypes.string,
  btnText: PropTypes.string,
  handleContinue: PropTypes.func
}

export default Step
